import {UserState} from '../interfaces/UserState';

export const state: UserState = {
  accessToken: '',
  userId: '',
  error: false,
  errorMessage: '',
  loading: false,
  response: false,
  balance: null,
  email: '',
  isNewUser: false,
};
